import { ProgressCircle } from '@react-spectrum/s2';
import { style } from '@react-spectrum/s2/style' with { type: 'macro' };

export const PageSpinner = () => {
	return (
		<div
			className={style({
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				height: '100vh',
			})}
		>
			<ProgressCircle size="L" isIndeterminate aria-label="Loading next page" />
		</div>
	);
};
